import { axios } from "./axios"
export * from "./customErrors"
export * from "./interceptors"

export { axios }

export default axios
